import Search from './components/Search';
import Marketing from './components/Marketing';
import Ads from './components/Ads';
import Specialty from './components/Specialty';
import Divider from '../common/components/Divider';
import DoctorInformation from './components/DoctorInformation';
import useAds from '../api/hooks/useAds';
import Calendar from './components/Calendar';
import { useEffect, useRef, useState } from 'react';
import PendingAppointments from '../doctorAppointmentManager/components/pendingAppointments/PendingAppointments';
// import AppointmentCalendar from '../components/appointmentCalendar/AppointmentCalendar';
import Axios from '../v2/services/Axios';
import { Carousel } from 'react-responsive-carousel';
import imgShapetwo from '../images/shape-2.png';
import imgShapethree from '../images/shape-3.png';
import sliderDoc from '../images/slider-doc.png';
import AppointmentPending from '../v2/pages/appointment-detail/doctor/AppointmentPending';
import DoctorPendingList from './components/DoctorPendingList';
import { Link } from 'react-router-dom';
export const DoctorProfile = {
  getME: () => Axios.get('/doctor-data/whoami')
};
export default function Home(props) {
  const { user, authenticatedUser } = props;
  const { adsToDisplay, onClickAd } = useAds();
  const [pendingAppointments, setPendingAppointments] = useState([]);
  const isDoctor = !!user && user.usertype === 2;
  const [error, setError] = useState('');

  //   useEffect(() => {
  //     window.scrollTo(0, 0);
  //     if (isDoctor) getPendingAppointment();
  //   }, []);

  //   const getPendingAppointment = async () => {
  //     let getHistory = await Axios.get('/appointment-doctor/history');
  //     if (getHistory && getHistory.pending) {
  //       setPendingAppointments(getHistory.pending);
  //       console.log(getHistory.pending);
  //     }
  //   };

  return (
    <>
      {/*Search*/}
      <div className="pt-12 lg:px-8 mx-auto px-4 relative sm:px-6">
        <h2 className="docter-link-title text-center">
          <b>Los especialistas médicos</b> reunidos en una sola plataforma
        </h2>
      </div>
      {error !== '' && (
        <div className="mb-8 bg-blue-100 border-t-4 border-blue-500 rounded-b text-blue-900 px-4 py-3 shadow-md" role="alert">
          <div className="flex">
            <div className="py-1">
              <svg className="fill-current h-6 w-6 text-blue-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
              </svg>
            </div>
            <div>
              <p className="font-bold mb-4">{error}</p>
              <Link to="/sign-in" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                Inicia sesión
              </Link>
            </div>
          </div>
        </div>
      )}
      {!isDoctor ? <Search /> : <AppointmentPending isHomeRoute={true} />}
      {!isDoctor ? (
        <>
          <Marketing setError={setError}/>
          <Ads adsToDisplay={adsToDisplay} onClickAd={onClickAd} />
          <div className="bg-dl-screen-lightblue pb-12 pt-20">
            <Specialty />
            {/* <Divider /> */}
          </div>
        </>
      ) : (
        <>
        <DoctorPendingList/>
        {/* <div className="slider-main py-20">
          <div className="wrapper-box">
            <div className="slider-inner">
              <div className="slider-left">
                <Carousel showStatus={false} showIndicators={false} showThumbs={false} autoPlay infiniteLoop interval={4000}>
                  <div>
                    <blockquote className="slider-content-box h-full	">
                      <h2 className="slider-title">Tu doctor a un solo clic</h2>
                      <ul className="list-disc">
                        <li>Programación en línea</li>
                        <li>Recordatorios de citas</li>
                        <li>Historial médico</li>
                        <li>Perfil personalizado</li>
                        <li>Aceptar/Rechazar citas</li>
                        <li>Acceso al estado de las citas</li>
                      </ul>
                    </blockquote>
                  </div>
                  <div>
                    <blockquote className="slider-content-box">
                      <h2 className="slider-title">tu doctor a un solo click</h2>
                      <ul className="list-disc">
                        <li>Aumenta tu visibilidad y construye tu reputación online</li>
                        <li>Ten el control total de tus citas</li>
                        <li>Aporta un servicio digital y de calidad a tus pacientes</li>
                      </ul>
                    </blockquote>
                  </div>
                </Carousel>
              </div>
              <div className="slider-right">
                <span className="shape-three">
                  <img src={imgShapethree} alt="" className="" />
                </span>
                <figure className="text-center">
                  {' '}
                  <img src={sliderDoc} alt="" className="" />
                </figure>
              </div>
            </div>
          </div>
        </div> */}
        </>
      )}
      {/*Ads*/}

      {/*Support*/}
      {/* <HelpAndSupportPage /> */}
      {/* Specialty List */}

      {/* Support Home div */}
      <DoctorInformation authenticatedUser={authenticatedUser} />
      {/* <ContactUsForDoctorsElement /> */}
      {/* Apps downloads */}
      {/* Mientras no tengamos las apps subidas a los markets no estara habilitado este componente */}
      {/*<DownloadAppElement />*/}
      {/* Footer */}
    </>
  );
}
